import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Image } from "antd";
import errorImag from "@/assets/images/common/errorImg.png";
import dzsjImg from "@/assets/images/common/dzsj.png";

const size = 175;
const logo = {
  src: dzsjImg,
  height: 40,
  width: 40,
}

const AddTaxOfficerRenderQRcode = (props) => {
  const { data } = props;
  const { qrcode } = data || {};
  if (data && qrcode) {
    return <QRCodeCanvas size={size} value={qrcode} title="电子税务局APP" imageSettings={logo} />;
  }
  return (
    <Image
      src={qrcode && `data:image/png;base64,${qrcode}`}
      alt="电子税务局APP"
      style={{ width: size, height: size }}
      preview={false}
      fallback={errorImag}
    />
  );
};

export default AddTaxOfficerRenderQRcode;
